var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "page-login" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("section", { staticClass: "login" }, [
      _c("div", { staticClass: "content" }, [
        _c("div", { staticClass: "login-form" }, [
          _c(
            "form",
            {
              staticClass: "form-horizontal form-material",
              attrs: { id: "registerform" },
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.submit.apply(null, arguments)
                },
                keydown: function ($event) {
                  return _vm.registerForm.errors.clear($event.target.name)
                },
              },
            },
            [
              _c("h1", [_vm._v("Great, let’s start raising capital for you!")]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Add your details, complete our first questionnaire, and we will match you with our investors and we will show you what kind of investor are suitable for your offering and where they are from. This is completely free of charge."
                ),
              ]),
              _vm._v(" "),
              _c("label", { attrs: { for: "first_name" } }, [
                _vm._v(_vm._s(_vm.trans("auth.first_name"))),
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.registerForm.first_name,
                    expression: "registerForm.first_name",
                  },
                ],
                attrs: { type: "text", name: "first_name" },
                domProps: { value: _vm.registerForm.first_name },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(
                      _vm.registerForm,
                      "first_name",
                      $event.target.value
                    )
                  },
                },
              }),
              _vm._v(" "),
              _c("show-error", {
                attrs: {
                  "form-name": _vm.registerForm,
                  "prop-name": "first_name",
                },
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "last_name" } }, [
                _vm._v(_vm._s(_vm.trans("auth.last_name"))),
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.registerForm.last_name,
                    expression: "registerForm.last_name",
                  },
                ],
                attrs: { type: "text", name: "last_name" },
                domProps: { value: _vm.registerForm.last_name },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.registerForm, "last_name", $event.target.value)
                  },
                },
              }),
              _vm._v(" "),
              _c("show-error", {
                attrs: {
                  "form-name": _vm.registerForm,
                  "prop-name": "last_name",
                },
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "email" } }, [
                _vm._v(_vm._s(_vm.trans("auth.email"))),
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.registerForm.email,
                    expression: "registerForm.email",
                  },
                ],
                attrs: { type: "text", name: "email" },
                domProps: { value: _vm.registerForm.email },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.registerForm, "email", $event.target.value)
                  },
                },
              }),
              _vm._v(" "),
              _c("show-error", {
                attrs: { "form-name": _vm.registerForm, "prop-name": "email" },
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "password" } }, [
                _vm._v(_vm._s(_vm.trans("auth.password"))),
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.registerForm.password,
                    expression: "registerForm.password",
                  },
                ],
                attrs: { type: "password", name: "password" },
                domProps: { value: _vm.registerForm.password },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.registerForm, "password", $event.target.value)
                  },
                },
              }),
              _vm._v(" "),
              _c("show-error", {
                attrs: {
                  "form-name": _vm.registerForm,
                  "prop-name": "password",
                },
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "password_confirmation" } }, [
                _vm._v(_vm._s(_vm.trans("auth.confirm_password"))),
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.registerForm.password_confirmation,
                    expression: "registerForm.password_confirmation",
                  },
                ],
                attrs: { type: "password", name: "password_confirmation" },
                domProps: { value: _vm.registerForm.password_confirmation },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(
                      _vm.registerForm,
                      "password_confirmation",
                      $event.target.value
                    )
                  },
                },
              }),
              _vm._v(" "),
              _c("show-error", {
                attrs: {
                  "form-name": _vm.registerForm,
                  "prop-name": "password_confirmation",
                },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "clear" }),
              _vm._v(" "),
              _c("div", { staticClass: "login-form-checkboxes" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.registerForm.tnc,
                      expression: "registerForm.tnc",
                    },
                  ],
                  attrs: { type: "checkbox", name: "terms", id: "terms" },
                  domProps: {
                    checked: Array.isArray(_vm.registerForm.tnc)
                      ? _vm._i(_vm.registerForm.tnc, null) > -1
                      : _vm.registerForm.tnc,
                  },
                  on: {
                    change: function ($event) {
                      var $$a = _vm.registerForm.tnc,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(_vm.registerForm, "tnc", $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              _vm.registerForm,
                              "tnc",
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(_vm.registerForm, "tnc", $$c)
                      }
                    },
                  },
                }),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.registerForm.newsletter,
                      expression: "registerForm.newsletter",
                    },
                  ],
                  attrs: {
                    type: "checkbox",
                    name: "newsletter",
                    id: "newsletter",
                  },
                  domProps: {
                    checked: Array.isArray(_vm.registerForm.newsletter)
                      ? _vm._i(_vm.registerForm.newsletter, null) > -1
                      : _vm.registerForm.newsletter,
                  },
                  on: {
                    change: function ($event) {
                      var $$a = _vm.registerForm.newsletter,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(
                              _vm.registerForm,
                              "newsletter",
                              $$a.concat([$$v])
                            )
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              _vm.registerForm,
                              "newsletter",
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(_vm.registerForm, "newsletter", $$c)
                      }
                    },
                  },
                }),
                _vm._v(" "),
                _c("label", { attrs: { for: "newsletter" } }, [
                  _vm._v(
                    "(Optional) Sign up to our Newsletter (you can unsubscribe at any time)."
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "button",
                { staticClass: "button", attrs: { type: "submit" } },
                [_vm._v("CONTINUE")]
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _vm._m(1),
        _vm._v(" "),
        _c("div", { staticClass: "clear" }),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("header", [
      _c("div", { staticClass: "content" }, [
        _c("a", { attrs: { href: "/" } }, [
          _c("img", {
            staticClass: "header-logo",
            attrs: { src: "/images/logo.svg" },
          }),
        ]),
        _vm._v(" "),
        _c(
          "a",
          { staticClass: "header-button-si", attrs: { href: "/login" } },
          [_vm._v("Sign In")]
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "login-hiw" }, [
      _c("h2", [_vm._v("Here’s how it works")]),
      _vm._v(" "),
      _c("ul", [
        _c("li", [
          _c("i", [_vm._v("1")]),
          _c("h3", [_vm._v("Complete our first questionnaire")]),
          _c("p", [
            _vm._v(
              "Tell us more about your investor preferences and your investment offering"
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("li", [
          _c("i", [_vm._v("2")]),
          _c("h3", [_vm._v("Get some free, suitable investor insights")]),
          _c("p", [_vm._v("based on the information submitted")]),
        ]),
        _vm._v(" "),
        _c("li", [
          _c("i", [_vm._v("3")]),
          _c("h3", [_vm._v("Book a video call with one of our experts")]),
          _c("p", [
            _vm._v("Our team will review your offering and give you a quote"),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "clear" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }